'use client'

import * as React from 'react'
import { clsx } from 'clsx'
import { useMedia } from '~/hooks/use-media'
import { getPlaygroundId } from '@basehub/data/replicache/playground/ids'

export const PlaygroundIframe = ({
  className,
  repository,
}: {
  className: string
  repository: string
}) => {
  const isTabletOrMobile = useMedia('(max-width: 1279px)')
  const [storedPlaygroundId, setStoredPlaygroundId] = React.useState<string>()

  React.useEffect(() => {
    const playgroundIdFromLocalStorage = localStorage.getItem('playgroundId')
    if (
      playgroundIdFromLocalStorage &&
      playgroundIdFromLocalStorage !== 'undefined'
    ) {
      setStoredPlaygroundId(playgroundIdFromLocalStorage)
    } else {
      const newPlaygroundId = getPlaygroundId()
      setStoredPlaygroundId(newPlaygroundId)
      localStorage.setItem('playgroundId', newPlaygroundId)
    }
  }, [])

  React.useEffect(() => {
    if (typeof window === 'undefined') return

    let lastScrollTop = window.scrollY

    const handleScroll = () => {
      lastScrollTop = window.scrollY
    }

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'iframeScrollIntoView') {
        window.scrollTo({ top: lastScrollTop, behavior: 'instant' })
      }
    }

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  if (!storedPlaygroundId || isTabletOrMobile) return null

  return (
    <iframe
      title="BaseHub repository playground"
      width={1200}
      height={800}
      suppressHydrationWarning
      onLoad={(e) => {
        const iframe = e.currentTarget as HTMLIFrameElement
        const win = iframe.contentWindow
        if (!win) return

        const patchScrollIntoView = () => {
          if ((Element.prototype as any)._patched) return
          const original = Element.prototype.scrollIntoView
          Element.prototype.scrollIntoView = function (...args) {
            parent.postMessage(
              { type: 'iframeScrollIntoView', id: this.id || null },
              '*'
            )
            original.apply(this, args)
          }
          ;(Element.prototype as any)._patched = true
        }

        ;(iframe.contentWindow as any).eval(
          `(${patchScrollIntoView.toString()})()`
        )
      }}
      src={`${repository}?playgroundId=${storedPlaygroundId}`}
      className={clsx(className, 'select-none')}
    />
  )
}
